// libraries
import { createGlobalStyle } from 'styled-components'
import { geekblue } from '@ant-design/colors'
import { media } from './context/media'
import * as OplevaltContext from './components/routes/oplevalt/context'

export const GlobalStyle = createGlobalStyle`
	:root {
		--sat: env(safe-area-inset-top);
		--sar: env(safe-area-inset-right);
		--sab: env(safe-area-inset-bottom);
		--sal: env(safe-area-inset-left);
	}

	html, body, #root {
		height: 100%;
	}

	body {
		margin: 0;
		padding: 0;
		background-color: white;
	}

	#root {
		position: relative;
		display: grid;
		grid-template-areas: 'sidebar header' 'sidebar main';
		grid-template-rows: auto 1fr;
		grid-template-columns: auto 1fr;
		background-color: white;
		
		main {
			grid-area: main;
			overflow: auto;
		}

		header {
			grid-area: header;
		}
		
		.sidebar {
			grid-area: sidebar;
		}

		.ant-form-horizontal .ant-form-item {
			margin-bottom: 1em;
		}
	}

	.dashboard-container {
		position: absolute;
		right: 0;
		width: 100vw;
		height: 100vh;
		overflow-y: auto;
	}

	.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
		text-shadow: none;
	}

	.oplevalt-row-dragging {
		background: ${OplevaltContext.theme.orange.neutral};
		box-shadow: 0 0 2rem #9996;

		td {
			padding: 0.8rem;
		}

		.fa-grip-lines {
			color: ${OplevaltContext.theme.orange.vibrant};
		}

		a.ant-typography {
			color: ${OplevaltContext.theme.orange.vibrant};
		}

		.ant-btn-primary {
			background-color: ${OplevaltContext.theme.orange.vibrant};
			border-color: ${OplevaltContext.theme.orange.vibrant};
		}

		.ant-switch-checked {
			background-color: ${OplevaltContext.theme.orange.vibrant};
		}
	}

	.vertical {
		display: flex;
		flex-direction: column;
	}

	.horizontal {
		display: flex;
		flex-direction: row;
	}

	.gap {
		gap: 1rem;
	}

	.aligned-center {
		align-items: center;
	}

	.align-self-center {
		align-self: center;
	}

	.justified-evenly {
		justify-content: space-evenly;
	}

	.justified-center {
		justify-content: center;
	}

	.wrap {
		flex-wrap: wrap;
	}

	.user-avatar {
		position: absolute;
		top: 0;
		right: 0;
		transform: translateY(50%);
		font-size: 0.6rem;
		width: 3ch;
		height: 3ch;
		line-height: 3ch;
		text-align: center;
		border-radius: 50%;
		z-index: 1;
	}
	
	img.user-avatar {
		padding: 2px;
		object-fit: cover;
	}

	@media only screen and (max-width: ${media.phoneMaxWidth}px) {
		#root {
			grid-template-areas: 'main' 'header';
			grid-template-rows: 1fr auto;
			grid-template-columns: 100vw;
		}

		header {
			border-top: 1px solid ${geekblue[0]};
		}

		.ant-back-top {
			bottom: calc(env(safe-area-inset-bottom) + 50px);
		}
	}

`
